module.exports = __webpack_public_path__ + "img/ru.073f6ef7.svg";